import { PayloadAction, configureStore, createSlice } from "@reduxjs/toolkit";

import authReducer from "./auth";
import { User } from "./backendTypes";

interface UserMapState {
  [key: number]: { value: User; ts: number } | undefined;
}

const initialUserMapState: UserMapState = {};

const usersSlice = createSlice({
  name: "users",
  initialState: initialUserMapState,
  reducers: {
    setUserMapState: (state, action: PayloadAction<User>) => {
      state[action.payload.employee.id] = {
        value: action.payload,
        ts: new Date().getTime(),
      };
    },
  },
});

export const { setUserMapState } = usersSlice.actions;

const initialEmployeesState: { items: User[] } = {
  items: [],
};

const employeesSlice = createSlice({
  name: "employees",
  initialState: initialEmployeesState,
  reducers: {
    setEmployeesState: (state, action: PayloadAction<User[]>) => {
      state.items = action.payload;
    },
  },
});

export const { setEmployeesState } = employeesSlice.actions;

const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersSlice.reducer,
    employees: employeesSlice.reducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
